import type { Ref } from 'vue'

interface TocSection {
  id: string
  title?: string
}

export function useJournalTocMode(
  sections: Ref<TocSection[]>,
  isLoading: Ref<boolean>,
) {
  const route = useRoute()

  const tocSections = computed(() =>
    sections.value.length > 1 ? sections.value : [],
  )

  const showContentOption = computed(() => tocSections.value.length > 0)

  const searchMode = ref(false)

  watch(isLoading, (loading) => {
    if (loading) {
      return
    }

    if (route.query.q) {
      searchMode.value = true
      return
    }

    searchMode.value = !showContentOption.value
  }, { immediate: true })

  watch(showContentOption, (canShow) => {
    if (!canShow) {
      searchMode.value = true
    }
  })

  return { tocSections, showContentOption, searchMode }
}
